import { newSendApiRequest } from './service-gateway';

export const uploadLogo = async (base64FileStr) => {
    return await newSendApiRequest('ProfileImage_save', [
        {
            parameter: 'imageFile',
            value: base64FileStr
        }
    ]);
};

export const getLogo = async () => {
    return await newSendApiRequest(
        'ProfileImage_read',
        [],
        undefined,
        undefined,
        false,
        undefined,
        undefined,
        undefined,
        true
    );
};

export const deleteLogo = async () => {
    return await newSendApiRequest('ProfileImage_delete', []);
};
